import { render, staticRenderFns } from "./criarTarefaWindow.vue?vue&type=template&id=28f37be6&"
import script from "./criarTarefaWindow.vue?vue&type=script&lang=js&"
export * from "./criarTarefaWindow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports